import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLeadsBoard from '@crm/ngrx/reducers/leads-board.reducer';

export interface State {
  leadsBoard: fromLeadsBoard.State;
}

export const reducers: ActionReducerMap<State, any> = {
  leadsBoard: fromLeadsBoard.reducer
};

export const selectLeadsBoardState = createFeatureSelector<fromLeadsBoard.State>('leadsBoard');

/** Select All Tasks */
export const selectAllTasks = createSelector(
  selectLeadsBoardState,
  fromLeadsBoard.selectAllTasks,
);

/** Select Filter */
export const selectFilter = createSelector(
  selectLeadsBoardState,
  (state) => state.filter
);

/** Select Loading */
export const selectLoading = createSelector(
  selectLeadsBoardState,
  (state) => state.loading
);

/** Select Task By ID */
export const selectTaskById = (taskId: string) => createSelector(
  selectLeadsBoardState,
  (state) => state.entities[taskId]
);
